// extracted by mini-css-extract-plugin
export var container = "_bq-0";